import type { User } from '../domain/user'

interface UserApiFormat {
    name: string
    email: string
    warehouse_id?: number
    role_id: number
    password?: string
    confirm_password?: string
}

export class UserToApiAdapter {
    static toApi(data: Omit<User, 'id'>): UserApiFormat {
        const result: UserApiFormat = {
            name: data.name,
            email: data.email,
            role_id: data.roleId,
            password: data.password,
            confirm_password: data.confirmPassword,
        }
        if (data.warehouseId !== undefined && data.warehouseId !== null) {
            result.warehouse_id = data.warehouseId
        }
        return result
    }

    static toApiPartial(
        data: Partial<Omit<User, 'id'>>
    ): Partial<UserApiFormat> {
        const result: Partial<UserApiFormat> = {}

        if (data.name !== undefined) result.name = data.name
        if (data.email !== undefined) result.email = data.email
        if (data.warehouseId !== undefined)
            result.warehouse_id = data.warehouseId
        if (data.roleId !== undefined) result.role_id = data.roleId
        if (data.password !== undefined) result.password = data.password
        if (data.confirmPassword !== undefined)
            result.confirm_password = data.confirmPassword

        return result
    }

    static fromApi(data: UserApiFormat): Omit<User, 'id'> {
        return {
            name: data.name,
            email: data.email,
            warehouseId: data.warehouse_id,
            roleId: data.role_id,
            password: data.password,
            confirmPassword: data.confirm_password,
        }
    }

    static fromApiPartial(
        data: Partial<UserApiFormat>
    ): Partial<Omit<User, 'id'>> {
        const result: Partial<Omit<User, 'id'>> = {}

        if (data.name !== undefined) result.name = data.name
        if (data.email !== undefined) result.email = data.email
        if (data.warehouse_id !== undefined)
            result.warehouseId = data.warehouse_id
        if (data.role_id !== undefined) result.roleId = data.role_id
        if (data.password !== undefined) result.password = data.password
        if (data.confirm_password !== undefined)
            result.confirmPassword = data.confirm_password

        return result
    }
}
